var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 2C10.512 2 2 10.512 2 21C2 31.488 10.512 40 21 40C31.488 40 40 31.488 40 21C40 10.512 31.488 2 21 2ZM21 36.2C12.602 36.2 5.8 29.398 5.8 21C5.8 12.602 12.602 5.8 21 5.8C29.398 5.8 36.2 12.602 36.2 21C36.2 29.398 29.398 36.2 21 36.2Z",
    fill: "#533F04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 23.8504C13.0739 23.8504 14.3499 22.5744 14.3499 21.0004C14.3499 19.4264 13.0739 18.1504 11.4999 18.1504C9.92589 18.1504 8.6499 19.4264 8.6499 21.0004C8.6499 22.5744 9.92589 23.8504 11.4999 23.8504Z",
    fill: "#533F04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 23.8504C22.5739 23.8504 23.8499 22.5744 23.8499 21.0004C23.8499 19.4264 22.5739 18.1504 20.9999 18.1504C19.4259 18.1504 18.1499 19.4264 18.1499 21.0004C18.1499 22.5744 19.4259 23.8504 20.9999 23.8504Z",
    fill: "#533F04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4994 23.8504C32.0734 23.8504 33.3494 22.5744 33.3494 21.0004C33.3494 19.4264 32.0734 18.1504 30.4994 18.1504C28.9254 18.1504 27.6494 19.4264 27.6494 21.0004C27.6494 22.5744 28.9254 23.8504 30.4994 23.8504Z",
    fill: "#533F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.8fde4cf40dc8408aa5ce89af25313e11.svg";
export { ForwardRef as ReactComponent };